export default "__VITE_ASSET__34b7eb44__"